import { render } from "./dentrion_comment.vue?vue&type=template&id=e3b910c8&scoped=true"
import script from "./dentrion_comment.vue?vue&type=script&lang=js"
export * from "./dentrion_comment.vue?vue&type=script&lang=js"

import "./dentrion_comment.vue?vue&type=style&index=0&id=e3b910c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b910c8"]])

export default __exports__